// Deccos management tenant. Members of this tenant see admin views
// (e.g. the MSI benchmark positions table instead of the anonymised scatter).
export const MONITOR_COMPAGNY_ID = '123423HJKHVKH'
